import CourseCard from './CourseCard';
import {
  CourseCardProps, CourseCardValueProps, CourseCardCombinedProps,
} from './types';

export type { CourseCardProps, CourseCardValueProps, CourseCardCombinedProps };
export default CourseCard;
